import * as constants from '../constants/staff';
import { pagination } from '../../config/settings';
import * as _ from 'lodash';
export const initialState = {
  item: null,
  credentials: null,
  list: [],
  totalCount: 0,
  loading: false,
  params: {
    ordering: 'id', limit: pagination.limit, offset: 0, search: null
  },
  pagesCount: 1,
  page: 1,
};

export default (state =  _.cloneDeep(initialState), action) => {
  switch (action.type) {
    case constants.GET_STAFF:
    case constants.GET_STAFF_MEMBER:
    case constants.UPDATE_STAFF:
    case constants.REMOVE_STAFF:
    case constants.REGENERATE_STAFF_CREDENTIALS:
      return {
        ...state,
        loading: true
      };

    case constants.GET_STAFF_ERROR:
    case constants.GET_STAFF_MEMBER_ERROR:
    case constants.UPDATE_STAFF_ERROR:
    case constants.REMOVE_STAFF_ERROR:
    case constants.REGENERATE_STAFF_CREDENTIALS_ERROR:
      return {
        ...state,
        loading: false,
      };

    case constants.GET_STAFF_MEMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        list: [],
        item: action.payload,
        totalCount: action.totalCount,
      };
    case constants.GET_STAFF_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload,
        item: null,
        totalCount: action.totalCount,
        pagesCount: Math.ceil(action.totalCount / pagination.limit)
      };

    case constants.EDIT_STAFF:
      return {
        ...state,
        item: action.data,
      };
    case constants.ADD_STAFF_SUCCESS:
    case constants.REGENERATE_STAFF_CREDENTIALS_SUCCESS:
      return {
        ...state,
        credentials: action.payload,
      };
    case constants.CLEAR_STAFF_CREDENTIALS:
      return {
        ...state,
        credentials: null,
      };
    case constants.STAFF_CHANGE_PARAMS:
      return {
        ...state,
        params: action.data,
      };
    case constants.STAFF_CHANGE_PAGE:
      return {
        ...state,
        page: +action.data,
      };

    default:
      return state;
  }
};